import { assertIsString } from '../../lib/test-and-assert/assert-base';
import { testIsCurrency } from './test';

function assertIsCurrency(maybeCurrency) {
    const msg = `value ${maybeCurrency} is not a valid currency - only 'usd'/'eur'/'inr' allowed`;

    assertIsString(maybeCurrency, msg);

    if (!testIsCurrency(maybeCurrency)) {
        throw new Error(msg);
    }
}

export { assertIsCurrency };
